<template>
  <div>
    <Layout :pagetitle="$t('Reward Profile')">
      <form autocomplete="off" @submit.prevent="saveReward">
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('Reward Profile') }}</h4>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col class="mt-2" md="12">
              <label>{{ $t('Name') }}</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="name" />
            </b-col>
            <b-col class="mt-2" md="12">
              <label>
                {{ $t('Rewards') }}
                <i
                  class="text-secondary mdi mdi-information cursor-pointer"
                  v-b-popover.hover="$t(`Não é possível selecionar mais de uma comissão do mesmo produto`)"
                />
              </label>
              <rewardSelector
                :checkProducts="true"
                @onValidateProducts="onValidateProducts"
                :modelValue="rewards"
                @onChange="selectRewards"
              />
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <div>
            <button
              type="submit"
              class="btn btn-primary m-1"
              v-if="$route.params.id"
              :disabled="$store.state.isLoading || hasDuplicatedProducts"
            >
              {{ $t('Update') }}
            </button>
            <button
              type="submit"
              class="btn btn-primary m-1"
              :disabled="$store.state.isLoading || hasDuplicatedProducts"
              v-else
            >
              {{ $t('Create') }}
            </button>
            <button type="button" class="btn btn-secondary m-1" @click="$router.back()">
              {{ $t('Back') }}
            </button>
          </div>
        </b-row>
      </form>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import rewardSelector from '@/components/selectors/rewardSelector.vue';

export default {
  components: { Layout, rewardSelector },
  data() {
    return {
      name: '',
      idCompany: null,
      rewards: [],
      hasDuplicatedProducts: false
    };
  },
  mounted() {
    if (this.$route.params?.id) {
      this.getReward();
    }
  },
  methods: {
    saveReward() {
      if (this.$route.params?.id) {
        this.updateReward();
      } else {
        this.createReward();
      }
    },
    getReward() {
      const rewardId = this.$route.params.id;
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get(`api/reward_profile/${rewardId}`, {})
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          let reward = res.data;

          this.name = reward.name;
          this.idCompany = reward.idCompany;
          this.rewards = reward.rewards;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: this.$t('Error')
          });
        });
    },
    createReward() {
      if (!this.validateReward()) return;
      let reward = {
        name: this.name,
        idCompany: this.idCompany,
        rewards: this.rewards
      };

      this.$store.commit('SET_LOADING', true);

      this.$api
        .post('api/reward_profile', reward)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });

          this.$router.push({
            name: 'rewardProfileList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Create reward error')
          });
        });
    },
    updateReward() {
      if (!this.validateReward()) return;
      let rewardId = this.$route.params.id;
      let reward = {
        name: this.name,
        idCompany: this.idCompany,
        rewards: this.rewards
      };

      this.$store.commit('SET_LOADING', true);
      this.$api
        .put(`api/reward_profile/${rewardId}`, reward)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          this.$router.push({
            name: 'rewardProfileList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Update reward error')
          });
        });
    },
    validateReward() {
      if (!this.name) {
        this.$customAlert({
          msg: this.$t('Invalid name'),
          type: 'error'
        });
        return false;
      }
      return true;
    },
    onValidateProducts(hasDuplicatedProducts = false) {
      this.hasDuplicatedProducts = hasDuplicatedProducts;
    },
    selectRewards(value) {
      this.rewards = value;
    }
  }
};
</script>

<style></style>
